const highlights = [
  {
    icon: "ri-cup-line",
    naslov: "Jutranja kava",
    opis: "Dober začetek dneva, brez hitenja.",
  },
  {
    icon: "ri-armchair-line",
    naslov: "Sproščeno vzdušje",
    opis: "Miren kotiček sredi mesta.",
  },
  {
    icon: "ri-user-smile-line",
    naslov: "Prostor za druženje",
    opis: "Za klepet in čas s prijatelji.",
  },
];

const dejstva = [
  { vrednost: "06.00", opis: "Odprto od" },
  { vrednost: "22.00", opis: "Delavniki do" },
  { vrednost: "24.00", opis: "Pet–sob do" },
];

export default function About() {
  return (
    <section id="o-nas" className="scroll-mt-24 bg-background-100 py-16 md:py-24 lg:py-28">
      <div className="section-shell">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-16">
          <div className="reveal relative">
            <div className="absolute -left-3 -top-3 hidden h-full w-full rounded-lg border border-accent-500/40 sm:block" />
            <div className="relative aspect-[4/5] w-full overflow-hidden rounded-lg">
              <img
                src="https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/02e3b3a2d47f6ede18e469d5d3b10b14.png"
                alt="Barski pult Bara Stanka na Ptuju z usnjenimi stoli, visečimi lučmi in rastlinami ob oknu"
                title="Barski pult – Bar Stanka Ptuj"
                className="h-full w-full object-cover object-center"
              />
            </div>
            <div className="absolute -bottom-6 right-4 hidden rounded-lg bg-primary-900 px-6 py-5 text-background-50 sm:block lg:-right-6">
              <p className="font-heading text-2xl italic text-accent-300">Ptuj</p>
              <p className="mt-1 font-label text-[9px] uppercase tracking-[0.24em] text-background-100/70">
                Zadružni trg 12D
              </p>
            </div>
          </div>

          <div className="reveal" style={{ transitionDelay: "120ms" }}>
            <div className="flex items-center gap-4">
              <span className="font-label text-[10px] font-semibold tracking-[0.2em] text-accent-700">
                01
              </span>
              <span className="rule-line" />
              <span className="eyebrow text-secondary-600">O nas</span>
            </div>

            <h2 className="headline mt-5 max-w-[520px] text-[31px] text-foreground-950 sm:mt-6 sm:text-[39px] lg:text-[48px]">
              Več kot le postanek
              <span className="block italic text-secondary-600">za kavo.</span>
            </h2>

            <p className="lead mt-5 max-w-[520px]">
              Bar Stanka je prijeten kotiček na Ptuju, kjer se vsakdanji trenutki
              spremenijo v priložnost za sprostitev. Ne glede na to, ali se
              ustavite na jutranji kavi, kratkem odmoru ali klepetu s prijatelji,
              vas pričaka prijetno in sproščeno vzdušje.
            </p>

            <div className="mt-8 grid max-w-[520px] grid-cols-3 divide-x divide-background-300 border-y border-background-300 py-5">
              {dejstva.map((item) => (
                <div key={item.opis} className="px-3 first:pl-0 last:pr-0">
                  <p className="font-heading text-[22px] leading-none text-foreground-950 sm:text-[26px]">
                    {item.vrednost}
                  </p>
                  <p className="mt-2 font-label text-[9px] uppercase tracking-[0.16em] text-foreground-500">
                    {item.opis}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-col divide-y divide-background-300/80 border-t border-background-300/80">
              {highlights.map((item, index) => (
                <div
                  key={item.naslov}
                  className="group flex items-start gap-4 py-4 transition-colors duration-500 first:pt-4"
                >
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-secondary-700 transition-colors duration-500 group-hover:bg-secondary-500 group-hover:text-background-50">
                    <i className={`${item.icon} text-lg`} />
                  </span>
                  <div className="flex-1">
                    <div className="flex items-baseline justify-between gap-4">
                      <h3 className="font-label text-[12.5px] font-semibold uppercase tracking-[0.12em] text-foreground-900">
                        {item.naslov}
                      </h3>
                      <span className="font-label text-[9px] tracking-[0.16em] text-foreground-400">
                        0{index + 1}
                      </span>
                    </div>
                    <p className="mt-1 text-sm text-foreground-600">{item.opis}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}